import React from "react";

import { Modal } from "antd";
import TableRadio from "../../../../components/Table";
import * as S from "../styles";
import { TModalListAnnuity } from "./types";
import { useModalListAnnuity } from "./useModalListAnnuity";
import DSButton from "../../../../components/DSButton";
import designSystemColors from "../../../../styles";
import ModalSelectStore from "./ModalSelectStore";

function ModalListAnnuities({
  closeModal,
  open,
  reloadPremiumAnnuity,
  listAnnuities,
}: TModalListAnnuity) {
  const {
    columnPremiumAnnuity,
    handleEngage,
    loading,
    rowSelection,
    openStoreModal,
    setOpenStoreModal,
    userStores,
    annuity,
    selectedRowKeys,
  } = useModalListAnnuity({
    closeModal,
    reloadPremiumAnnuity,
    open,
  });

  return (
    <>
      <Modal
        visible={open}
        onCancel={closeModal}
        width={800}
        title="Contratar anuidade"
      >
        <S.ModalContainer>
          <TableRadio
            rowKey="id"
            rowSelection={{ type: "radio", ...rowSelection }}
            rows={listAnnuities}
            columns={columnPremiumAnnuity}
            page={10}
          />
        </S.ModalContainer>
        <S.ModalBodyAnnuity style={{ display: "flex", justifyContent: "end" }}>
          <DSButton
            isCancelType
            buttonText="Cancelar"
            onClick={() => closeModal()}
            buttonType="primary"
          />

          <DSButton
            onClick={() => handleEngage()}
            buttonText="Contratar"
            buttonType="primary"
            isLoading={loading}
            isDisabled={loading || selectedRowKeys.length === 0}
            disabled={loading || selectedRowKeys.length === 0}
            dataTestId="button-submit-annuity-with-one-store"
            style={{
              border: "none",
              backgroundColor: designSystemColors.generalButtons,
            }}
          />
        </S.ModalBodyAnnuity>
      </Modal>

      <ModalSelectStore
        open={openStoreModal}
        changeOpenState={() => {
          setOpenStoreModal(!openStoreModal);
          closeModal();
        }}
        userStores={userStores}
        closeModal={() => setOpenStoreModal(!openStoreModal)}
        annuity={annuity}
        selectedRowKeys={selectedRowKeys}
        reloadPremiumAnnuity={reloadPremiumAnnuity}
      />
    </>
  );
}

export default ModalListAnnuities;
